module.exports = __webpack_public_path__ + "img/salonpas_pain_relieving_patches.896949f8.jpg";